import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc50 = {
    title: "Image 50:  Examples of an accessible witness box and accused box.",
    para1: <>
        <p>The image has two pictures of two accessible witness box(es)/accused box(es). The image on the left is a wooden witness stand in a courtroom. The witness box is equipped with mechanical lifts with buttons to manoeuvre to improve accessibility.</p>
        <p>The image on the right is of a similar witness box where the portable/removable ramp has been attached.</p>
    </>,
}

export const FigureDesc34 = {
    title: "Figure 34: Users of the Courtroom. ",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            The figure shows a 3D render of a Courtroom. The features of the space are described in a clockwise direction.
        </p>
        <p>
            <span><b>Description:</b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "A door for public entry/exit to the Courtroom from the corridor/waiting area is provided at the bottom left of the layout.",
                    "Upon entering through this door, two rows for general seating are provided towards the back of the Courtroom. The second row has provisions for wheelchair-accessible seating on either side of the row. This area is indicated in the key as A.",
                    "In front of the general seating and towards the centre of the Courtroom, four seats and a table have been provided for lawyers. This is indicated in the key as B.",
                    <>
                        To the north-west direction of the lawyer seating, the accused box is situated. The box includes provision for seating for two accused persons and the accompanying police inspector. This is indicated in the key as C.
                        {getCircleTypeListItem([
                            "The police inspector also has provision for additional seating adjacent to the accused box, close to the general seating. "
                        ])}
                    </>,
                    "The accused box is situated next to the dais. This is indicated in the key as D.",

                    "Another door is shown at the bottom right of the layout, which is a secured entry through which the accused arrives.",

                    <>
                        Upon the dais, which spans the top side of the Courtroom, provision has been made for a table for the Judge sitting in the centre (indicated in the key as F), with a stenographer and a clerk seated on either side of the Judge. They are indicated in the key as E and G respectively.
                        {getCircleTypeListItem([
                            "Empanelled wall-to-wall storage has also been provided towards the back of the dais.",
                            "Additionally, towards the back of the dais and at the top right of the layout, a separate doorway is provided for access to the Judge’s Chamber. This is indicated in the key as a restricted entry dedicated for Judges only.",

                        ])}
                    </>,

                    "At the right side of the dais, and directly opposite to the accused box, the witness box is situated. The witness box includes provision for seating for a witness and a support person.",
                    "The accused box and the witness box are separated by the table for evidence. Provision has been made for digital and IT facilities at this table, as well as seating for Court staff.",

                    "From the witness box on the right side of the Courtroom, a secure entry/exit doorway is provided at the bottom right of the layout. ",

                    "A ramp is provided from this secure entry/exit doorway directly to the dais.",

                    "The witness box, accused box and the general seating area/lawyers area are at the same level and are separated from the Judge’s dais by a low partition wall.",

                    "Along the partition wall a table is provided for placing the evidence or for other court personnel to sit when necessary.",

                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc35 = {
    title: "Figure 35: Sectional elevation for the dais and the witness box. ",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            the features of the Judge’s bench and the witness box are described separately in plan and in section.
        </p>
        <p>
            <span><b>Description:</b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <><span><b>Judges Bench plan- </b>the Judges bench has a duress button, an adjustable work surface, a cable tray, a raised bench with a computer and a custom casework shell.</span></>,
                    "The duress button is provided to the right of the Judge for easy access.",
                    "The length of the raised bench is 1445mm and the width is 25mm. There is a  custom casework shell attached to the raised bench.",
                    "The width of the cable tray is 475mm. ",
                    <><span><b>Judges Bench section- </b></span>
                        the table has a provision of a mic. Behind the mic is provided a modular adjustable work surface.
                    </>,
                    "Behind the table is a custom casework shell with ballistic shielding.",
                    "The table is provided with an adjustable keyboard tray.",
                    "The dias of the Judge is raised at a width of 300mm from the surface.",
                    <><span><b>Witness box- </b></span>
                        there is a ramp access at the entrance to the witness box on the right side of the figure.
                    </>,
                    "The length and the width of the witness box is 1800mm and 450mm respectively. ",
                    "The witness box has two chairs and two microphones. One of the tables of the witness box has a computer system.",
                    "The table also has an optional removable screen to the left of the witness",
                    "The dias of the witness box is raised at a width of 300mm from  the surface.",

                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc36 = {
    title: "Figure 36: Typical floor plan for Courtroom Type-A (PDJ Courtroom).",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            The two public entrances to the Courtroom plan are on the left side of the layout.
        </p>
        <p>The features of the space are described in a counter-clockwise direction, starting from the bottom left. </p>
        <p>
            <span><b>Description:</b></span>

            <div className="figure_desc">
                {generateUnOrderedList([
                    "The first public entrance is provided at the bottom left of the floor plan.",
                    "At the front of this entrance, a ramp of ratio 1:12 with a turning diameter of 1500 mm at the beginning, leads up to the dias from within the Courtroom.",
                    "Behind the dais, a door with turning diameter 1500 mm has been provided which leads to the Judges’ Chambers/Corridor at the bottom right of the floor plan. The dais is also made accessible from the side of the Judges’ Chambers/Corridor for diverse users by using a ramp of ratio 1:12 and tactile pavers.",
                    <>
                        Seating has been provided for the Court Clerk, Judge and Stenographer on the dais which measures 11000 mm x 2750 mm and with turning diameter 1500 mm.
                        {getCircleTypeListItem([
                            "The table for the Court Clerk is to the left of the entrance to the Judges’ Chamber.",
                            "The table of the Judge is to the left of the Court Clerk. This marks the centre of the dais.",
                            "The table for the Stenographer is to the left of the Judges’ table. This is at the top right corner of the floor plan. ",
                            "All three tables have provisions for accessible digital technology including computer systems, mics, etc.",

                        ])}
                    </>,
                    "The rest of the wall behind the dais has storage cupboards, at a distance of 1000 mm from the seating provisions.",

                    "To the left of the ramp leading up to the dais, the witness box (measuring 1950 mm x 1950 mm, and turning diameter 1500 mm) has been provided. The witness box is not elevated, has two chairs and is also equipped with accessible digital technology.",

                    "To the left of the witness box, a table has been used that runs the entire length of the dais. This table can be used by the Public Prosecutors in criminal Courts. The table is also meant for presenting evidence and has space for other support persons who may assist the Court or the litigants including translators.",

                    "To the left of the evidence table, the accused box (measuring 1950 mm x 2400 mm, and turning diameter 1500 mm) is located. The accused box is also not elevated and has digital technology.",

                    "A chair has been placed next to the accused box to the left for the accompanying police officer.",

                    "In front of the accused box, to the right of the seat for the police officer, a table has been placed for advocates.",

                    "The table has space for 4 lawyers and has chairs and digital technology.",

                    "To the left of the chair for the police officer, the other entrance to the Courtroom has been provided. This is at the top left corner of the floor plan",

                    "To the right of this entrance to the Courtroom, and at a distance of 2100 mm behind the lawyer seating, two rows of seating has been placed for the general public, separated by a space of 900 mm.",

                    "Space has been provided for accessible seating at either ends of the front row.",
                    <>
                        Court Clerk Room:
                        {getCircleTypeListItem([
                            "Outside the Courtroom and adjoining it, on the top of the plan, a room measuring 6500 mm x 3000 mm has been provided for a Court Clerk (Sheristedar/Ahlmad) with storage facilities and digital technology."
                        ])}
                    </>
                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc37 = {
    title: "Figure 37: Representation of the PDJ Courtroom.",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            The figure shows a 3D render of a Courtroom. The features of the space are described in a clockwise direction.
        </p>
        <p>
            <span><b>Description:</b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "A door for public entry/exit to the Courtroom is provided at the bottom left of the layout.",
                    "Upon entering through this door, two rows for general seating are provided towards the back of the Courtroom. The second row has provisions for wheelchair-accessible seating on either side of the row.",
                    "In front of the general seating and towards the centre of the Courtroom, four seats and a table have been provided for lawyers.",
                    <>
                        To the north-west direction of the lawyer seating, the accused box is situated. The box includes provision for seating for two accused persons and the accompanying police inspector.
                        {getCircleTypeListItem([
                            "The police inspector also has provision for additional seating adjacent to the accused box, close to the general seating."
                        ])}
                    </>,
                    "The accused box is situated next to the dais.",
                    <>
                        Upon the dais, which spans the top side of the Courtroom, provision has been made for a table for the Judge sitting in the centre, with a stenographer and a clerk seated on either side of the Judge.
                        {getCircleTypeListItem([
                            "Empanelled wall-to-wall storage has also been provided towards the back of the dais.",
                            "Additionally, towards the back of the dais and at the top right of the layout, a separate doorway is provided for access to the Judge’s Chamber.",

                        ])}
                    </>
                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc38 = {
    title: "Figure 38: Representation of hierarchy of District Court Judges in India.",
    para1: <>
        <p>
            The figure illustrates the hierarchy of the District Courts in India. The figure has a central box which indicates the Court of the Principal District Judge which is the highest in hierarchy and has two columns which show the hierarchy in the Civil (left column) and Criminal side (right column).  The hierarchy is such that the bottom-most row is the lowest Court in the hierarchy.
        </p>
        <p className="figure_desc">
            {generateUnOrderedList([
                "Civil Side: The lowest Court is the Court of Small Causes, followed by the Court of Civil Judge (Junior Division) and the Court of Civil Judge (Senior Division).",
                "Criminal Side: The lowest Court is the Court of the Judicial Magistrate (Second Class), followed by the Judicial Magistrate (First Class) and the Court of the Chief Judicial Magistrate.",

            ])}
        </p>
    </>,
}

export const FigureDesc39 = {
    title: "Figure 39: Typical floor plan for Courtroom Type-B (Other Judges). ",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            The two public entrances to the Courtroom plan are on the left side of the layout.
        </p>
        <p>The features of the space are described in a counter-clockwise direction, starting from the bottom left. </p>
        <p>
            <span><b>Description:</b></span>
            <div className="figure_desc"> {generateUnOrderedList([
                "The first public entrance is provided at the bottom left of the floor plan.",
                "The ramp of ratio 1:12 and turning diameter 1500 mm, leading up to the dias from within the Courtroom is in front of this entrance.",
                "Behind the dais, a door with turning diameter 1500 mm has been provided which leads to the Judges’ Chambers/Corridor at the bottom right of the floor plan. The dais is also made accessible from the side of the Judges’ Chambers/Corridor for diverse users by using a ramp of ratio 1:12 and tactile pavers.",
                <>
                    Seating has been provided for the Court Clerk, Judge and Stenographer on the dais which measures 11000 mm x 2750 mm and turning diameter 1500 mm.
                    {getCircleTypeListItem([
                        "The table for the Court Clerk is to the left of the entrance to the Judges’ Chamber.",
                        "The table of the Judge is to the left of the Court Clerk. This marks the centre of the dais.",
                        "The table for the Stenographer is to the left of the Judges’ table. This is at the top right corner of the floor plan.",
                        "All three tables have provisions for accessible digital technology including computer systems, mics, etc.",
                    ])}
                </>,

                "The rest of the wall behind the dais has storage cupboards, at a distance of 1000 mm from the seating provisions.",

                "To the left of the ramp leading up to the dais, the witness box (measuring 1950 mm x 1950 mm, and turning diameter 1500 mm) has been provided. The witness box is not elevated, has two chairs and is also equipped with accessible digital technology.",

                "To the left of the witness box, a table has been used that runs the entire length of the dais. This table can be used by the Public Prosecutors in criminal Courts. The table is also meant for presenting evidence and has space for other support persons who may assist the Court or the litigants including translators.",

                "To the left of the evidence table, the accused box (measuring 1950 mm x 2400 mm, and turning diameter 1500 mm) is located. The accused box is also not elevated and has digital technology.",

                "A chair has been placed next to the accused box to the left for the accompanying police officer.",

                "In front of the accused box, to the right of the seat for the police officer, a table has been placed for advocates.",

                "The table has space for 4 lawyers and has chairs and digital technology.",

                "To the left of the chair for the police officer, the other entrance to the Courtroom has been provided. This is at the top left corner of the floor plan",

                "To the right of this entrance to the Courtroom, and at a distance of 2100 mm behind the lawyer seating, two rows of seating has been placed for the general public, separated by a space of 900 mm.",

                "Space has been provided for accessible seating at either ends of the front row.",
                <>
                    Court Clerk Room:
                    {getCircleTypeListItem([
                        "Outside the Courtroom and adjoining it, on the top of the plan, a room measuring 6500 mm x 3000 mm has been provided for a Court Clerk (Sheristedar/Ahlmad) with storage facilities and digital technology."
                    ])}
                </>
            ])}
            </div>
        </p>
    </>,
}

export const FigureDesc40 = {
    title: "Figure 40: Typical floor plan for Courtroom Type-D (POCSO Courtroom).",
    para1: <>
        <p><span><b>Orientation of the Floor Plan: </b></span>
            The POCSO Courtroom with VWDC facilities has 13 spaces. These include an outdoor play area, separate entrance, public lobby, counsellor room, public pantry and common washroom facilities, waiting room, washroom, deposition room, feeding room, POCSO Courtroom, accused dock and Court clerk room. This space is referred to as the POCSO Complex or Complex.
        </p>
        <p>The features are being described space by space. This has been designed to be on the ground floor of a Court building. </p>
        <p>
            <span><b>Description:</b></span>
            {getCircleTypeListItem([
                <>
                    Outdoor Play Area
                    <div className="figure_desc">
                        {generateUnOrderedList([
                            "The outdoor play area is at the bottom left corner of the floor plan.",
                            "The play area has accessible equipment and features for children such as wall marimba, sandpit, wheelchair sandpit, spring rider and emperor chimes (musical instrument). ",
                            "Greenery is also provided in the play area.",
                            "The play area also has drinking water provisions.",
                            "To the right of the play area is the entrance to the complex. ",
                        ])}
                    </div>
                </>,
                <>
                    Entrance to the POCSO Complex
                    <div className="figure_desc">
                        {generateUnOrderedList([
                            "The entrance to the POCSO Complex has a ramp on the right and a staircase to the left with tactile pavers to make it accessible to diverse user groups.",
                            "The ramp leads to a landing where seating has been provided for two security guards.",
                            "The landing has enough space for a wheelchair to turn and also has potted plants to ensure that it is not intimidating.",
                            "The entrance leads to a lobby.",

                        ])}
                    </div>
                </>,
                <>
                    Lobby
                    <div className="figure_desc">
                        {generateUnOrderedList([
                            "The lobby is to the right of the play area as per the floor plan and behind the entrance. ",
                            "A lobby has been provided so as to be an additional waiting area apart from the waiting area prescribed under VWDC.",
                            "The lobby has been provided with seating along with a provision for a wheelchair.",
                            "It also has a wall mounted digital case display screen.",
                            "There are three doors leading out from the lobby -  to the POCSO Courtroom, counsellor’s room and public pantry.",

                        ])}
                    </div>
                </>,
                <>
                    Counsellor’s Room
                    <div className="figure_desc">
                        {generateUnOrderedList([
                            "The counsellor’s room has been provided with comfortable sofa set seating along with a table.",
                            "An office table has been provided for the counsellor with ergonomic chairs.",
                            "The table also has a computer.",
                            "A cupboard has been provided for storage facilities.",
                            "Accessible drinking water provisions have been given.",

                        ])}
                    </div>
                </>,
                <>
                    Public Pantry
                    {getCircleTypeListItem([
                        "The public pantry has a platform ledge with storage below it.",
                        "The storage is provided for keeping snack items.",
                        "The public pantry has a door to the left leading to the drinking water facilities and the accessible gender neutral washroom facilities.",
                        "The public pantry has a second door leading to the waiting room.",

                    ])}
                </>,
                <>
                    Common Washroom
                    {getCircleTypeListItem([
                        "The washroom has been provided with an accessible wash basin, urinal and an Indian toilet. "
                    ])}
                </>,
                <>
                    Waiting Room
                    {getCircleTypeListItem([
                        "The waiting room has a comfortable sofa set, a bean bag and additional floor seating.",
                        "It has a sensory board.",
                        "It also has a case display screen and drinking water facilities.",
                        "Space has been given for a pantry area and it leads to an accessible, gender neutral washroom.",
                        "The waiting room has two additional doors leading to the deposition room and a feeding room.",

                    ])}
                </>,
                <>
                    Deposition Room
                    {getCircleTypeListItem([
                        "The deposition room has been provided with a comfortable sofa set seating.",
                        "The room has a screen and microphone for the victim/witness to be able to give their deposition comfortably.",
                        "The room has a child play area with a sensory board.",
                        "Seating has been provided for a technician or Court clerk to use if necessary.",

                    ])}
                </>,
                <>
                    Feeding Room
                    {getCircleTypeListItem([
                        "The feeding room has been provided with a comfortable sofa with a table to keep necessities.",
                        "The room is well ventilated with a window and has storage facilities.",

                    ])}
                </>,
                <>
                    POCSO Courtroom
                    {getCircleTypeListItem([
                        "The third door from the lobby leads to the POCSO Courtroom.",
                        "The Courtroom is being described in a clockwise manner.",
                        "The door is at the bottom middle of the Courtroom. ",
                        "A chair has been provided to the right of the door to the left of the door for a police inspector/guard. To the right is a sofa seat.",
                        "The Judge's dais is to the right of the chair.",
                        "Seating has been provided for the Court Clerk, Judge and Stenographer on the dais.",
                        "Behind the dais, a door has been provided which leads to the Judges’ Chambers/Corridor which is at the bottom right of the floor plan. The dais is also made accessible from the side of the Judges’ Chambers/Corridor for diverse users by using a ramp and tactile pavers.",
                        "The table for the Court Clerk is to the left of the entrance to the Judges’ Chamber",
                        "The table of the Judge is to the left of the Court Clerk. This marks the centre of the dais.",
                        "The table for the Stenographer is to the left of the Judges’ table. This is at the top right corner of the Courtroom floor plan.",
                        "All three tables have provisions for accessible digital technology including computer systems, mics, etc.",
                        "The rest of the wall behind the dais has storage cupboards.",
                        `Parallel to the Judge's dias are two tables, one for evidence and the other for a special Public Prosecutor along with computers.`,
                        "To the left of the Stenographer there is a ramp leading down to the Courtroom. This is to ensure that the dais is accessible to all. ",
                        "Seating has been provided for two police inspectors where the ramp ends.",
                        "To the right of the chairs is another entrance to the Courtroom.",
                        "A door has also been provided to an accused dock which is separated from the Courtroom with a one-way mirror and a mic.",
                        "The accused dock is also equipped with a sofa seating and a chair.",
                        "The accused dock has seating for the accused with digital technology. ",
                        "To the left of the police inspector seating, outside the dock, limited seating has been provided for family members along with a provision for wheelchairs.",
                        "Space has been provided for accessible seating at either ends of the front row.",
                        "In front of the police inspector chairs, a table has been placed for advocates.",
                        "The table has space for 4 lawyers and has chairs and digital technology.",

                    ])}
                </>,
                <>
                    Court Clerk Room
                    <div className="figure_desc">
                        {generateUnOrderedList([
                            "Outside the Courtroom, a room has been provided for a Court Clerk (Shirestedar/Ahlmad) with storage facilities and digital technology."
                        ])}
                    </div>
                </>,


            ], false, "a")}
        </p>
    </>,
}

